<template>
  <String class="string--blue" :strLength="this.strLength">
    <Green :brightness="channelOneBrightness"/>
    <Green :brightness="channelTwoBrightness"/>
  </String>
</template>

<script>
  import String from './String';
  import Green from '../Lights/Green';

  export default {
    name: 'BlueString',
    components: {
      String,
      Green
    },
    props: {
      channelOneBrightness: Number,
      channelTwoBrightness: Number,
      strLength: {
        type: Number,
        default: 20
      }
    }
  };
</script>

<style>

</style>
